export default __webpack_public_path__ + "static/media/housing-assistance-cap60.94840917.jpeg";